<template>
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="52" fill="#062633" />
    <g clip-path="url(#clip0_584_10012)">
      <path
        d="M29.8062 22.048C30.673 21.6355 31.4184 20.9987 31.9669 20.2074C32.5092 19.3886 32.863 18.4577 33.0033 17.4845C33.175 16.4415 33.1164 15.5318 32.8316 14.7596C32.5511 13.9895 31.9962 13.3506 31.2781 12.9655C30.5327 12.5297 29.5299 12.3118 28.2715 12.3118H23.8685L22.1433 22.7039H26.5589C27.8256 22.7039 28.908 22.486 29.8083 22.0501L29.8062 22.048Z"
        fill="white"
      />
      <path
        d="M16.8025 12.8723C9.49552 15.3836 7.61747 24.9442 13.4212 30.0832L14.2461 30.8131L17.2275 12.7263L16.8025 12.8723Z"
        fill="white"
      />
      <path
        d="M38.8511 11C39.0333 11.3216 39.1924 11.6601 39.3243 12.0092C39.9356 13.5917 40.078 15.4175 39.7472 17.4866C39.4415 19.4711 38.6711 21.354 37.5028 22.981C36.3533 24.5635 34.8249 25.8307 33.062 26.6622C31.2426 27.5423 29.1406 27.9824 26.7537 27.9824H21.2683L19.9597 35.8695L22.9097 38.4824C28.7134 43.6213 37.8461 40.4838 39.3494 32.8357L41.8053 20.3385C42.5234 16.653 41.2149 13.2553 38.8511 11Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_584_10012">
        <rect width="32" height="30" fill="white" transform="translate(10 11)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts"></script>
